import PropTypes from 'prop-types';
import React from 'react';
import { JobContextConsumer } from '../../../contexts/JobContext';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';

import './TopCompany.scss';

export default class TopCompany extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isFollowed: this.props.isFollowed,
        };
    }

    static propTypes = {
        position: PropTypes.string,
        average: PropTypes.number,
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.number,
        }),
        companyId: PropTypes.number,
        companyName: PropTypes.string,
        companyUrl: PropTypes.string,
        isFollowed: PropTypes.bool,
    };

    static defaultProps = {};

    handleFollowClick = (followCompany, userId) => {
        followCompany(this.props.companyId);
        EmitMetric({
            company_id: this.props.companyId,
            misc_event_type: 'follow-company',
            misc_event_count: 1,
            user_id: userId,
        });
        this.setState({ isFollowed: true });
    };

    renderFollowingButton = () => {
        return <button className="white-grey-btn">Following</button>;
    };

    renderFollowButton = () => {
        return (
            <PageConsumer>
                {(pageContext) => (
                    <JobContextConsumer>
                        {(jobContext) =>
                            pageContext.wrapAuth(
                                'top-companies',
                                <button
                                    className="bluey-grey-btn"
                                    onClick={() =>
                                        this.handleFollowClick(
                                            jobContext.followCompany,
                                            pageContext.pageProps.session.id
                                        )
                                    }
                                >
                                    Follow
                                </button>,
                                { login_trigger: 'follow-company' }
                            )
                        }
                    </JobContextConsumer>
                )}
            </PageConsumer>
        );
    };

    renderCTAButton = () => {
        return this.state.isFollowed
            ? this.renderFollowingButton()
            : this.renderFollowButton();
    };

    renderMobileFollowCompany = () => {
        return (
            <div className="follow-company d-block d-md-none pl-0 pr-0">
                {this.renderCTAButton()}
            </div>
        );
    };

    render() {
        const injectedTransforms = {
            xSmall: 'c_lpad,f_auto,q_auto,w_60,h_60',
        };

        const imagePath = buildImagePath(
            this.props.logo.src,
            this.props.size || 'xSmall',
            injectedTransforms
        );

        return (
            <div className="component-Ratings-TopCompany row-md">
                <div className="img">
                    <a href={`/company-overview/${this.props.companyUrl}`}>
                        <img src={imagePath} />
                    </a>
                </div>

                <div className="info-wrap col-md-10 row-md pl-md-0 pr-md-0">
                    <div className="info col-md-9 pl-md-1 pr-md-0">
                        <div className="item-title">
                            <a
                                href={`/company-overview/${this.props.companyUrl}`}
                            >
                                <span>
                                    {truncateWithEllipsis(
                                        this.props.companyName,
                                        52
                                    )}
                                </span>
                            </a>
                        </div>

                        <div className="score-wrapper pt-1">
                            <div className="score">
                                Score {this.props.average}
                            </div>
                            {this.renderMobileFollowCompany()}
                        </div>
                    </div>

                    <div className="follow-company d-none d-md-block pl-0 pr-0">
                        {this.renderCTAButton()}
                    </div>
                </div>
            </div>
        );
    }
}
